import { Permissions } from 'models/permissions';
import { User } from 'models/user';
import { Reducer } from 'redux';

import { GET_USERS, SET_USERS, UserActions } from './user.types';

export interface UserState {
  user?: User;
  permissions?: Permissions;
  users: Array<User>;
  loadingUsers: boolean;
}

const initialSettings: UserState = {
  user: undefined,
  permissions: undefined,
  users: [],
  loadingUsers: false
};

const userReducer: Reducer<UserState, UserActions> = (
  state: UserState = initialSettings,
  action: UserActions
) => {
  const parameters: any = {};

  switch (action.type) {
    case GET_USERS:
      parameters.loadingUsers = true;
      break;

    case SET_USERS:
      parameters.loadingUsers = true;
      break;
  }

  return {
    ...state,
    ...action.payload,
    parameters
  };
};

export default userReducer;
